import { useEffect, useRef } from "react";
import { Link, NavLink, Navigate, Outlet, useLocation } from "react-router";
import { useAuth } from "../auth/AuthProvider.js";
import { adminCopy } from "../copy/zh-CN.js";
import "./admin.css";

export function AdminLayout() {
  const { state } = useAuth(); const { pathname } = useLocation(); const main = useRef<HTMLElement>(null);
  useEffect(() => { main.current?.focus(); }, [pathname]);
  if (state.status !== "authenticated") return null;
  if (state.user.role !== "system_admin") return <Navigate to="/projects" replace />;
  return <div className="admin-shell">
    <a className="admin-skip" href="#admin-main">跳到主要内容</a>
    <aside className="admin-sidebar">
      <Link className="admin-brand" to="/projects"><span aria-hidden="true">S</span> Seedance Studio</Link>
      <p className="admin-eyebrow">{adminCopy.title}</p>
      <nav aria-label="管理后台导航">
        <NavLink to="/admin" end>管理总览</NavLink>
        <NavLink to="/admin/members">成员管理</NavLink>
        <NavLink to="/admin/usage">用量记录</NavLink>
        <NavLink to="/admin/tasks">生成任务</NavLink>
        <NavLink to="/admin/feedback">失败反馈</NavLink>
        <NavLink to="/admin/audit">操作记录</NavLink>
      </nav>
      <div className="admin-account"><strong>{state.user.username}</strong><span>系统管理员</span><Link to="/projects">← 返回我的项目</Link></div>
    </aside>
    <main className="admin-main" id="admin-main" ref={main} tabIndex={-1}><Outlet /></main>
  </div>;
}
